import React from 'react';
import "./css/carousel.css";


function Carousel() {
    return (

        <div id="carouselExampleIndicators" className="carousel carousel-fade carousel_laptop slide" data-ride="carousel">
            <div className="carousel-inner">

                <div className="carousel-item active">
                    <img loading="lazy" className="d-block w-100" id="img4" src="https://image.shutterstock.com/image-photo/indian-sweets-plate-includes-gulab-260nw-1196218465.jpg" alt="..." />
                </div>
                <div className="carousel-item">
                    <img loading="lazy" className="d-block w-100" id="img3" src="https://static.toiimg.com/photo/87304656.cms" alt="..." />
                </div>
                <div className="carousel-item">
                    <img loading="lazy" className="d-block w-100" id="img2" src="https://static.toiimg.com/photo/87304656.cms" alt="..." />
                </div>
                <div className="carousel-item">
                    <img loading="lazy" className="d-block w-100" id="img1" src="https://static.toiimg.com/photo/87304656.cms" alt="..." />
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon move-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span class="carousel-control-next-icon move-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    )
}

export default Carousel;
